// utils/fetchData.js

const fetchAndStoreData = async () => {
  try {
    const response = await fetch(
      "https://json-backend.vercel.app/json/6a03dddfd83cd9537791421e",
    );
    const result = await response.json();
    localStorage.setItem('apiData', JSON.stringify(result.data));
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

window.addEventListener('load', fetchAndStoreData);

export const getStoredData = () => {
  const storedData = localStorage.getItem('apiData');
  return storedData ? JSON.parse(storedData) : null;
};
